var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8144 8.62012V11.8457M21.8144 27.9737V31.1993M21.8144 18.2969V21.5225M4.07361 15.0713C5.35683 15.0713 6.5875 15.5811 7.49487 16.4885C8.40225 17.3958 8.91201 18.6265 8.91201 19.9097C8.91201 21.1929 8.40225 22.4236 7.49487 23.331C6.5875 24.2384 5.35683 24.7481 4.07361 24.7481V27.9737C4.07361 28.8292 4.41345 29.6496 5.01836 30.2546C5.62328 30.8595 6.44373 31.1993 7.29921 31.1993H33.104C33.9595 31.1993 34.7799 30.8595 35.3849 30.2546C35.9898 29.6496 36.3296 28.8292 36.3296 27.9737V24.7481C35.0464 24.7481 33.8157 24.2384 32.9083 23.331C32.001 22.4236 31.4912 21.1929 31.4912 19.9097C31.4912 18.6265 32.001 17.3958 32.9083 16.4885C33.8157 15.5811 35.0464 15.0713 36.3296 15.0713V11.8457C36.3296 10.9902 35.9898 10.1698 35.3849 9.56487C34.7799 8.95996 33.9595 8.62012 33.104 8.62012H7.29921C6.44373 8.62012 5.62328 8.95996 5.01836 9.56487C4.41345 10.1698 4.07361 10.9902 4.07361 11.8457V15.0713Z",
    stroke: "white",
    strokeWidth: 1.6128,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.b4913ab378be0ebc2143e95e9a99a3ed.svg";
export { ForwardRef as ReactComponent };